import React from "react";
import { Link } from "react-router-dom";
import { PageHero, Section, Eyebrow, SectionTitle } from "../components/Primitives";
import { Sunrise, BookOpen, Home, HandHeart, GraduationCap, Utensils, HeartHandshake, Flower2 } from "lucide-react";

const programs = [
  { Icon: Sunrise, t: "Weekly Meditation", tag: "Practice", d: "Guided evening meditation on Thursdays and Sundays, plus Sunday morning dharma. All levels welcome, cushions provided." },
  { Icon: BookOpen, t: "Dharma Study Circle", tag: "Learning", d: "Small-group study of Buddhist texts, meeting fortnightly in English and Vietnamese. A gentle place to ask any question." },
  { Icon: Home, t: "Rahula Community Lodge", tag: "Housing", d: "Safe, low-cost accommodation for travellers, students, and people in transition — offered on a supported-housing model." },
  { Icon: Utensils, t: "Karuna Vegetarian Kitchen", tag: "Meals", d: "Free vegetarian meals for anyone who is hungry, offered after Sunday service and on festival days." },
  { Icon: HandHeart, t: "Emergency Relief Fund", tag: "Relief", d: "Small, dignified emergency assistance for individuals and families facing hardship — no forms, no barriers." },
  { Icon: GraduationCap, t: "Vietnamese Language Class", tag: "Culture", d: "Saturday classes for children and adults — keeping language, story and heritage alive across generations." },
  { Icon: HeartHandshake, t: "Family Counselling", tag: "Care", d: "Confidential, culturally-sensitive counselling and chaplaincy for individuals, couples and families in distress." },
  { Icon: Flower2, t: "Youth & Elders Groups", tag: "Belonging", d: "Weekly meetups for young people and monthly gatherings for elders, over tea, food and shared craft." },
];

const Programs = () => (
  <>
    <PageHero
      eyebrow="Programs & Services"
      title="Twelve quiet ways we try to help."
      subtitle="Every program below is free or low-cost, open to anyone who needs it, and delivered by trained volunteers alongside our resident monastics."
    />

    <Section>
      <div className="grid md:grid-cols-2 gap-8">
        {programs.map(({ Icon, t, tag, d }) => (
          <article key={t} className="p-8 border border-[#e9dcc0] bg-[#fdfaf3] hover:border-[#c9a15b] hover:shadow-[0_20px_40px_-24px_rgba(61,40,23,0.35)] transition-all duration-300">
            <div className="flex items-center gap-3 mb-4">
              <Icon size={28} className="text-[#7a2e1f]" strokeWidth={1.5} />
              <span className="text-[10px] uppercase tracking-[0.25em] text-[#8a6b3f]">{tag}</span>
            </div>
            <h3 className="font-serif text-2xl text-[#3d2817]">{t}</h3>
            <p className="mt-3 text-[15px] text-[#5a4a3a] leading-relaxed">{d}</p>
          </article>
        ))}
      </div>
    </Section>

    <section className="bg-[#f6efe0] border-y border-[#e9dcc0]">
      <div className="max-w-4xl mx-auto px-6 lg:px-10 py-24 text-center">
        <Eyebrow>Access</Eyebrow>
        <SectionTitle className="mt-6">Everyone is welcome. Truly, everyone.</SectionTitle>
        <p className="mt-6 text-lg text-[#5a4a3a] leading-relaxed">
          Our programs are open regardless of faith, background, age, gender, orientation, ability or means. If you’re unsure whether something is for you — it is. Please just come, or send us a note first.
        </p>
        <div className="mt-10 flex flex-wrap gap-4 justify-center">
          <Link to="/contact" className="btn-primary">Get in touch</Link>
          <Link to="/visit" className="btn-outline">Visit us</Link>
        </div>
      </div>
    </section>
  </>
);

export default Programs;
